'use es6';

import UnifiedAnalyticsViewFilterEditor from 'reporting-enablement/components/reportEditors/UnifiedAnalyticsViewFilterEditor/UnifiedAnalyticsViewFilterEditor';
import { getAnalyticsViewFilters, getSingleFilterValue } from 'reporting-enablement/components/reportEditors/UnifiedAnalyticsViewFilterEditor/analyticsViewUtils';
import { WithUserInfoProvider } from 'reporting-ui-components/components/PlatformReport/UserInfoProvider';
import { jsx as _jsx } from "react/jsx-runtime";
const AnalyticsViewControlWithUserInfo = WithUserInfoProvider(UnifiedAnalyticsViewFilterEditor);
const AnalyticsViewControl = ({
  report,
  updateContext
}) => {
  return /*#__PURE__*/_jsx(AnalyticsViewControlWithUserInfo, {
    report: report,
    onChange: updatedReport => {
      const matchedFilters = getAnalyticsViewFilters(updatedReport);
      const analyticsView = matchedFilters.get('analyticsView');
      const subdomain = matchedFilters.get('subdomain');
      updateContext({
        analyticsView: getSingleFilterValue(analyticsView),
        domain: getSingleFilterValue(subdomain)
      }, report);
    }
  });
};
AnalyticsViewControl.isUsableForReport = ({
  report
}) => {
  return UnifiedAnalyticsViewFilterEditor.isUsableForReport(report);
};
export default AnalyticsViewControl;